import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CompaniesMiniEntity } from '../../domain/entities/CompaniesMiniEntity'
import type { CompanyListedAdminDto } from '@/backend/market'

export class CompaniesMiniModel extends CompaniesMiniEntity {
  constructor(dataDto: CompanyListedAdminDto) {
    super()
    mapEntityProperties<CompaniesMiniEntity>(this, dataDto)
  }
}
